import { getTimeFromFetchStart } from 'mini-performance/lib/utils/getTimeFromFetchStart';
import { MAILLIST_RENDERED } from 'mini-mail-common/lib/utils/eventSignalConstants';

export const LSRLogging = appContext =>
    requestAnimationFrame(() => {
        const beforePaintTime = getTimeFromFetchStart();
        setTimeout(() => {
            appContext.signal(MAILLIST_RENDERED, {
                afterPaintTime: getTimeFromFetchStart(),
                beforePaintTime,
            });
        }, 0);
    });
